import List from '../ListView/list'
import { MODE } from '../../constant'
import PageAdd from '../ListView/add/pageAdd'
import EmbedAdd from '../ListView/add/embedAdd'
import ModalAdd from '../ListView/add/modalAdd'
import eventHub from '../../utils/eventHub'
import routerKit from '../../utils/routerKit';

export function generateComponent(type, configs) {
  return {
    name: 'NestedListView',
    render(h) {
      let resChild = null
      let Add = null
      switch (configs.mode) {
        case MODE.EDIT_IN_DIALOG:
          Add = ModalAdd
          break
        case MODE.EDIT_IN_NEW_PAGE:
          Add = PageAdd
          break
        case MODE.EDIT_IN_TABLE:
          Add = EmbedAdd
          break
      }
      switch (type) {
        case 'list':
          return (
            <div class="sp-nested-view">
              <h1>{this.$i18n(`${configs.data.resourceName} List`)}</h1>
              <List
                class={`list-wrapper sp-${configs.data.name}-list`}
                resourceType="nested"
                mode={configs.mode}
                data={configs.data}
                schema={configs.schema}
                actions={configs.actions}
                hooks={configs.hooks}
                options={configs.options}
                on-triggerSearch={async params => {
                  const loadingInstance = this.$loading({ target: '.list-wrapper' })
                  await configs.data.fetch.list(this.$store, params)
                  loadingInstance.close()
                }}
                on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
                on-triggerUpdate={async params => {
                  // TODO: after moving 'fetch' action to store, cb is useless
                  await configs.data.update(this.$store, params.data)
                  params.cb && params.cb()
                }}
                on-triggerDelete={async params => {
                  // TODO: after moving 'fetch' action to store, cb is useless
                  await configs.data.delete(this.$store, params.data)
                  params.cb && params.cb()
                }}
                on-addHandle={this.addHandler}
                on-editHandle={this.editHandler}
                on-detailHandle={this.detailHandler}
              />
            </div>
          )
        case 'add':
          return (
            <Add
              class={`sp-${configs.data.name}`}
              schema={configs.schema}
              data={configs.data}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
            />
          )
          break
        case 'edit':
          return (
            <Add
              class={`sp-${configs.data.name}`}
              schema={configs.schema}
              data={configs.data}
              model={configs.data.provider.one(this.$store.state)}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
            />
          )
          break
        case 'detail':
          return (
            <Add
              class={`sp-${configs.data.name}`}
              schema={configs.schema}
              data={configs.data}
              model={configs.data.provider.one(this.$store.state)}
              isDetail={true}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
            />
          )
          break
        default:
          return <div></div>
      }
    },
    data() {
      return {
        cancelText: this.$i18n('Confirm Cancel ?'),
        confirmText: this.$i18n('Confirm ?'),
        confirming: false,
        defaultFormData: {}
      }
    },
    methods: {
      confirm() {
        if (this.confirming) return
        this.confirming = true
        const resourceName = configs.data.resourceName.toLocaleLowerCase() + '_id'
        this.formData[resourceName] = this.formData[resourceName] || this.formData['id']
        this.$confirm(this.confirmText).then(async () => {
          if (this.model) {
            if (this.data && this.data.update) {
              await this.data.update(this.$store, this.formData)
            }
          } else {
            if (this.data && this.data.add) {
              await this.data.add(this.$store, this.formData)
            }
          }
          eventHub.$emit('closeSubPage')
          this.confirming = false
        }).catch(() => this.confirming = false)
      },
      cancel() {
        this.$confirm(this.cancelText)
          .then(() => eventHub.$emit('closeSubPage'))
          .catch(() => {})
      },
      addHandler() {
        const { prefix, name, viewMode } = routerKit.parse(this.$route.path)
        this.$router.push(`${prefix}/${name}/${configs.data.name}Add/${viewMode}`)
      },
      editHandler(query) {
        const { prefix, name, viewMode } = routerKit.parse(this.$route.path)
        this.$router.push({
          path: `${prefix}/${name}/${configs.data.name}Edit/${viewMode}`,
          query
        })
      },
      detailHandler(query) {
        const { prefix, name, viewMode } = routerKit.parse(this.$route.path)
        this.$router.push({
          path: `${prefix}/${name}/${configs.data.name}Detail/${viewMode}`,
          query
        })
      }
    },
    created() {
      this.$emit('triggerSearch')
    }
  }
}

export default function NestedListViewFactory(resource) {
  const components = {}
  resource.forEach(item => {
    components[`${item.data.name}`] = generateComponent('list', item)
    components[`${item.data.name}Add`] = generateComponent('add', item)
    components[`${item.data.name}Edit`] = generateComponent('edit', item)
    components[`${item.data.name}Detail`] = generateComponent('detail', item)
  })
  return components
}



// WEBPACK FOOTER //
// ./packages/creator/NestedListView/index.js